import { createI18n } from "vue-i18n";
import en from "./locales/en.json";
import es from "./locales/es.json";
import { getStoredDevLocale } from "./components/composables/devLocaleHelpers";

const defaultLocale = import.meta.env.VUE_APP_I18N_LOCALE || "es";
const resolvedLocale = getStoredDevLocale() || defaultLocale;

export default createI18n({
  legacy: false,
  locale: resolvedLocale,
  fallbackLocale: import.meta.env.VUE_APP_I18N_FALLBACK_LOCALE || "en",
  messages: {
    en,
    es,
  },
});
